import {LobbyImage} from '@colonist/types'
import {createDivIn, createImgIn, createParagraphIn} from '../../ui_utils/DomUtils'
import {AnalyticEventCategory, AnalyticEventType, GiftingFlowAnalytics} from '../../../../../shared/entity_datas/EntityDatas'
import {CA} from '../../analytics/Analytics'
import {AjaxDataTypes} from '../../../../../shared/AjaxDataTypes'

export abstract class UIStoreGiftBaseSelectionController {
    protected readonly parentDiv: HTMLDivElement
    protected readonly hideGiftOverlayAction: () => void

    protected topNavigationButton: HTMLDivElement
    protected tabOrderNumberContainer: HTMLDivElement
    protected selectionTitle: HTMLDivElement
    protected tabOrderNumber: HTMLParagraphElement
    protected checkmark: HTMLImageElement
    readonly sidebarContainer: HTMLDivElement

    protected titleAndContentContainer: HTMLDivElement
    protected pageContainer: HTMLDivElement
    protected pageTitle: HTMLDivElement

    protected mainCTAButton: HTMLDivElement

    private readonly checkoutAction: () => void

    constructor(parentDiv: HTMLDivElement, sidebarContainer: HTMLDivElement, hideGiftOverlayAction: () => void, checkoutAction: () => void) {
        this.parentDiv = parentDiv
        this.hideGiftOverlayAction = hideGiftOverlayAction
        this.sidebarContainer = sidebarContainer
        this.createSidebarButton()
        this.createPageContent()
        this.topNavigationButton.addEventListener('click', () => this.select())
        this.checkoutAction = checkoutAction
    }

    protected createSidebarButton() {
        this.topNavigationButton = createDivIn(this.sidebarContainer, 'store-gift-sidebar-button')
        const childCount = this.sidebarContainer.children.length
        this.tabOrderNumberContainer = createDivIn(this.topNavigationButton, 'store-gift-sidebar-order-number')
        this.tabOrderNumber = createParagraphIn(this.tabOrderNumberContainer, {key: 'strings:colonistCommon.utils.#buffer', options: {value: `${childCount}`}}, '')
        this.checkmark = createImgIn(this.tabOrderNumberContainer, LobbyImage.CheckMark, 'store-gift-sidebar-checkmark')
        this.checkmark.classList.add('hidden')

        this.selectionTitle = createDivIn(this.topNavigationButton, 'store-gift-sidebar-title')
    }

    select() {
        for(const child of this.parentDiv.children) child.classList.add('hidden')
        for(const child of this.sidebarContainer.children) child.classList.remove('selected')
        this.topNavigationButton.classList.add('selected')
        this.titleAndContentContainer?.classList.remove('hidden')
    }

    makePageFirst() {
        this.parentDiv.prepend(this.titleAndContentContainer)
        this.sidebarContainer.prepend(this.topNavigationButton)
        let tabNumber = 1
        for(const child of this.sidebarContainer.children) {
            if(child.classList.contains('store-gift-sidebar-button')) {
                const tabOrderNumber = child.querySelector('.store-gift-sidebar-order-number p')
                if(tabOrderNumber) tabOrderNumber.textContent = `${tabNumber}`
                tabNumber += 1
            }
        }
    }

    selectNextPage() {
        UIStoreGiftBaseSelectionController.sendGiftFlowAnalytics(GiftingFlowAnalytics.SuccessfulPageCompletion)
        this.titleAndContentContainer.classList.add('hidden')
        this.topNavigationButton.classList.remove('selected')
        this.markAsCompleted(true)

        const nextPageContent = this.titleAndContentContainer.nextElementSibling
        const nextSidebarButton = this.topNavigationButton.nextElementSibling
        nextPageContent?.classList.remove('hidden')
        nextSidebarButton?.classList.add('selected')
    }

    markAsCompleted(isCompleted: boolean) {
        if(isCompleted) {
            this.tabOrderNumberContainer.classList.add('completed')
            this.tabOrderNumber.classList.add('hidden')
            this.checkmark.classList.remove('hidden')
        } else {
            this.tabOrderNumberContainer.classList.remove('completed')
            this.tabOrderNumber.classList.remove('hidden')
            this.checkmark.classList.add('hidden')
        }
    }

    enableNextButton() {
        this.mainCTAButton?.classList.remove('disabled')
    }

    disableNextButton() {
        this.mainCTAButton?.classList.add('disabled')
    }

    protected createPageContent() {
        this.titleAndContentContainer = createDivIn(this.parentDiv, 'store-gift-page-container')
        this.pageTitle = createDivIn(this.titleAndContentContainer, 'store-gift-page-title')
        const backButton = createImgIn(this.pageTitle, LobbyImage.LeftArrow)
        backButton.addEventListener('click', () => this.selectPreviousPage())
        this.pageContainer = createDivIn(this.titleAndContentContainer, 'store-gift-page-content')
    }

    protected createNextButton(): HTMLDivElement {
        const nextButton = createDivIn(this.pageContainer, 'store-gift-overlay-main-cta-button')
        createParagraphIn(nextButton, {key: 'strings:storePage.sections.giftOverlay.recipientSelection.next'}, '')
        nextButton.addEventListener('click', () => nextButton.classList.contains('disabled') ? null : this.selectNextPage())
        nextButton.classList.add('disabled')
        return nextButton
    }

    protected createCheckoutButton(): HTMLDivElement {
        const checkoutButton = createDivIn(this.pageContainer, 'store-gift-overlay-main-cta-button')
        createParagraphIn(checkoutButton, {key: 'strings:storePage.checkout.checkout'}, '')
        checkoutButton.addEventListener('click', () => checkoutButton.classList.contains('disabled') ? null : this.checkoutAction())
        return checkoutButton
    }

    private selectPreviousPage() {
        const previousPageContent = this.titleAndContentContainer.previousElementSibling
        const previousSidebarButton = this.topNavigationButton.previousElementSibling

        if(!previousPageContent || !previousSidebarButton) return this.hideGiftOverlayAction?.()
        this.titleAndContentContainer.classList.add('hidden')
        this.topNavigationButton.classList.remove('selected')

        previousPageContent?.classList.remove('hidden')
        previousSidebarButton?.classList.add('selected')
    }

    static sendGiftFlowAnalytics(analytic: GiftingFlowAnalytics) {
        const giftButtonClickEventData: AjaxDataTypes.AnalyticData = {
            type: AnalyticEventType.GiftingFlowAnalytic,
            category: AnalyticEventCategory.GiftMembershipOverlay,
            floatValue: analytic,
        }
        void CA.sendAnalyticEvent(giftButtonClickEventData)
    }
}
